import { CardCollections as CardCollection } from '@ampdx/component-library/dist/components/index'
import { reactToCwp } from '../../common/react-utils.jsx'
export default reactToCwp(CardCollection)
